import {ProductPage} from 'modules/product-card/pages/ProductPage';
import {NextPage} from 'next';
import {productControllerByCode} from 'modules/product-card/controller';
import {withBasicDataServerSide} from 'core/next/controllers';
import {ProductPageProvider} from 'modules/product-card/providers';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData, selectProductSeo} from 'modules/product-card/selectors';
import {PageHead} from 'core/modules/PageHead';
import {useViewPDPGtag} from 'modules/product-card/analytics/gtag/hooks/useViewPDPGtag';
import {GFScript} from 'modules/gravityfield/GFScript';
import {ISeo} from 'modules/seo/types';
import {useRedirect} from 'modules/product-card/hooks/useRedirect';

const ProductDetailedPage: NextPage<{pageProps: {seo: ISeo}}> = ({pageProps}) => {
    const {seo} = pageProps;
    const productSeo = useAppSelector(selectProductSeo);
    const productData = useAppSelector(selectProductData);

    const {robots, metaDescription, metaTitle = ''} = productSeo || {};

    useViewPDPGtag();
    useRedirect({redirect: seo?.redirect});

    return (
        <>
            <PageHead description={metaDescription} title={metaTitle} robots={robots} />
            <ProductPageProvider seo={seo}>
                <ProductPage />
            </ProductPageProvider>
            {productData?.id && <GFScript type={'PRODUCT'} data={[productData.id]} />}
        </>
    );
};

export const getServerSideProps = withBasicDataServerSide(async (store, ctx) => {
    const seo = await productControllerByCode(store, ctx as any);

    return {props: {seo}};
});

export default ProductDetailedPage;
